import React from 'react';

export const Avatar: React.FC<{
    name: string | null;
	size?: string;
}> = ({
    name, size = '2.5rem' 
}) => {
	// Combine the general and additional glossy colors as available colors
	const AVAILABLE_COLOR_VARS = [
        "var(--general-blue)",
        "var(--general-purple)",
        "var(--general-red)",
        "var(--general-orange)",
        "var(--general-yellow)",
        "var(--general-green)",
        "var(--general-dark-blue)",
        "var(--general-dark-green)",
        "var(--additional-blue-light)",
        "var(--additional-blue-dark)",
        "var(--additional-purple-dark)",
        "var(--additional-red-dark)",
        "var(--additional-orange-dark)",
        "var(--additional-green-dark)",
        "var(--additional-pink)",
        "var(--additional-teal)"
    ];

    // Fall back to an empty string so a null or undefined name never crashes below
    const safeName = name || '';

    // Generate the initials to show inside the avatar
	const initials = (() => {
        // If the name is empty, return a question mark
        if (!safeName) {
            return '?';
        }

        // Split the name into its parts
		const parts = safeName.trim().split(/\s+/);

        // If the name consists of one part, get the first two letters
		if (parts.length === 1) {
			return parts[0].substring(0, 1).toUpperCase();
		}

        // Otherwise get the first letter of the first two parts
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	})();

	// Get a fixed color based on a hash of the name
	const generatedColor = (() => {

        // Generate the hash based on the given name
		let hash = 0;
		for (let i = 0; i < safeName.length; i++) {
			hash = safeName.charCodeAt(i) + ((hash << 5) - hash);
		}

        // Generate the index for the color to pick
		const index = Math.abs(hash) % AVAILABLE_COLOR_VARS.length;

        // Return the color variable
		return AVAILABLE_COLOR_VARS[index];
	})();

    // Extract the numeric rem value and generate font size
    const fontSize = (() => {
		const match = size.match(/([\d.]+)rem/);
		const numeric = match ? parseFloat(match[1]) : 1;
		return `${numeric * 0.4}rem`;
	})();

	// Generate avatar style
	const style: React.CSSProperties = {
		width: size,
		height: size,
		borderRadius: '50%',
		backgroundColor: generatedColor,
		color: '#ffffff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
        fontFamily: "var(--header-font-regular)",
		fontWeight: 600,
		fontSize,
		userSelect: 'none'
	};

	return <div style={style}>{initials}</div>;
};